
import React from 'react';
import PropTypes from 'prop-types';
import { marked } from 'marked';
import './styles/styles.scss';

const MarkdownToHtml = (props) => {
  const { markdown } = props;
  return (
    <div className="markdown-content" dangerouslySetInnerHTML={{ __html: marked.parse(markdown) }} />
  );
};
MarkdownToHtml.propTypes = {
  markdown: PropTypes.string,
};
export default MarkdownToHtml;
